/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Icon, SurveyFormModal } from 'iron-man';
import './index.less';
import React from 'react';


export const FormContentCheckbox = ({ title, desc, active, onClick, maxWidth, flex, ...props }) => {
  const style = {};
  if (maxWidth && maxWidth !== "unset") style.maxWidth = maxWidth + "px";
  if (flex && flex !== "unset") style.flex = flex;

  return (
    <button
      className={"form-content-checkbox" + (active ? " active" : "")}
      style={style}
      onClick={onClick}
      title={title}
      type="button"
      {...props}
    >
      <div style={{ display: "flex", flexDirection: "row", alignItems: "flex-start", width: "100%" }}>
        <div className="form-content-checkbox__icon">
          {active ? (
            <img
              src={`${process.env.PUBLIC_URL}/images/check-filled-blue.svg`}
              style={{ width: 24, height: 24 }}
              alt="selected"
            />
          ) : (
            <img
              src={`${process.env.PUBLIC_URL}/images/circle-check-gray.svg`}
              style={{ width: 24, height: 24 }}
              alt="unselected"
            />
          )}
        </div>
        <div className="form-content-checkbox__content">
          <div className="form-content-checkbox__title">{title}</div>
          {desc &&  <div className="form-content-checkbox__desc">{desc}</div>}
        </div>
      </div>
    </button>
  );
};

export default FormContentCheckbox;
